import styled from "styled-components";
import useAppSettingsService from "../../hooks/useAppSettingsService";
import { useMaintenanceModeContext } from "../../context/MaintenanceMode/MaintenanceModeContext";
import { useAuthContext } from "../auth/AuthContext";
import { Roles } from "../../constant/Roles";

const Banner = styled.div`
  background-color: #c0392b;
  color: #fff;
  text-align: center;
  padding: 0.5rem 1rem;
  font-weight: 500;
`;

const TurnOffLink = styled.button`
  background: none;
  border: none;
  padding: 0;
  margin-left: 0.5rem;
  color: #fff;
  text-decoration: underline;
  cursor: pointer;
  font-weight: 600;
  font-size: inherit;
  height: 20px;

  &:hover {
    color: #ffdad6;
  }
`;

const MaintenanceModeBanner = () => {
  const { isMaintenance, setIsMaintenance } = useMaintenanceModeContext();
  const { user } = useAuthContext();
  const appSettingsService = useAppSettingsService();

  const isAdmin = user?.roles.includes(Roles.ADMINISTRATOR) ?? false;

  if (!isMaintenance || !isAdmin) return null;

  const handleTurnOff = () => {
    appSettingsService.createAppSettings({ isMaintenance: false }).then(() => {
      setIsMaintenance(false);
    });
  };

  return (
    <Banner>
      App currently in maintenance mode
      <TurnOffLink onClick={handleTurnOff}>turn off</TurnOffLink>
    </Banner>
  );
};

export default MaintenanceModeBanner;
